const TIDAL_TRACKING_STAGE_ENDPOINT = 'https://et.stage-v2.tidalhi.fi/api/public/events';
const TIDAL_TRACKING_PROD_ENDPOINT = 'https://et.tidal.com/api/public/events';
const TIDAL_TOKEN = 'WEB';

const tidalAxiosConfig = {
    enableRequestLogging: false,
    shouldLogError: /** @param {import("axios").AxiosError} axiosError */ axiosError => {
        return !!axiosError.response && axiosError.response.status >= 500;
    },
    shouldRetry: /** @param {import("axios").AxiosError} axiosError */ axiosError => {
        return !!axiosError.response && [503, 504].includes(axiosError.response.status);
    },
};

module.exports = {
    tidalAxiosConfig,
    TIDAL_TOKEN,
    TIDAL_TRACKING_PROD_ENDPOINT,
    TIDAL_TRACKING_STAGE_ENDPOINT,
};

